import Dashboard from './pages/Dash.svelte';
import Login from './pages/Login.svelte';
import Register from './pages/Register.svelte';
import Shipment from './pages/Shipment.svelte';
import Shipments from './pages/Shipments.svelte';
//import ShipmentsLikut from './pages/ShipmentsLikut.svelte';
import Settings from './pages/Settings.svelte';
import Integration from './pages/Integration.svelte';
import Locations from './pages/Locations.svelte';
import Services from './pages/Services.svelte';
import Companies from './pages/Companies.svelte';
import Empty from './pages/Empty.svelte';
import Support from './pages/Support.svelte';
//import WorkflowBuilder from './pages/WorkflowBuilder.svelte';
import CustomersDashboard from './pages/CustomersDashboard.svelte';
import Create_Customer from './pages/Create_Customer.svelte';
import Rest from './pages/docs/Rest.svelte';
import Wordress from './pages/docs/Wordpress.svelte';
import Shopify from './pages/docs/Shopify.svelte';
import Konimbo from './pages/docs/Konimbo.svelte';
import Wix from './pages/docs/Wix.svelte';
import Docs from './pages/docs/Docs.svelte';
import Merchandiser_Categories from './pages/merchandiser/Categories.svelte';
import Merchandiser_Views from './pages/merchandiser/Views.svelte';
import Merchandiser_View from './pages/merchandiser/View.svelte';
import Merchandiser_Support from './pages/merchandiser/Support.svelte';
import Merchandiser_Docs from './pages/merchandiser/Docs.svelte';
import Bot_Airtable from './pages/bot/Airtable.svelte';
import Bot_Airtable_Tables from './pages/bot/Airtable_Tables.svelte';
import Bot_Airtable_Table from './pages/bot/Airtable_Table.svelte';
import Bots from './pages/bot/Bots.svelte';
import Bot from './pages/bot/Bot.svelte';

import AgentsDashboard from './pages/agents/Dashboard.svelte';
import AgentsCart from './pages/agents/Cart.svelte';
import AgentsCarts from './pages/agents/Carts.svelte';
import AgentsProduct from './pages/agents/Product.svelte';
import AgentsProducts from './pages/agents/Products.svelte';
import AgentsOrders from './pages/agents/Orders.svelte';

const mainRoutes = {
    '/agents/carts' : AgentsCarts,
    '/agents/carts/:cart_id' : AgentsCart,
    '/agents/products' : AgentsProducts,
    '/agents/products/:cart_id' : AgentsProducts,
    '/agents/product' : AgentsProduct,        
    '/agents/dashboard' : AgentsDashboard,
    '/agents/orders' : AgentsOrders,        


    '/integrations' : Integration,
    '/bot/bots' : Bots,
    '/bot/bots/:id/' : Bot,
    '/bot/bases' : Bot_Airtable,
    '/bot/bases/:base_id/tables' : Bot_Airtable_Tables,
    '/bot/bases/:base_id/tables/:table_id' : Bot_Airtable_Table,
    '/merchandiser/support' : Merchandiser_Support,
    '/merchandiser/docs' : Merchandiser_Docs,
    '/merchandiser/view/:view_id' : Merchandiser_View,
    '/merchandiser/views/:category_id' : Merchandiser_Views,
    '/merchandiser/categories' : Merchandiser_Categories,
    '/create_customer' : Create_Customer,
    '/my_customers/:user_id' : CustomersDashboard,
    '/customers' : CustomersDashboard,
    
    '/' : AgentsProducts,

    //'/workflowbuilder' : WorkflowBuilder,

    '/support' : Support,

    '/dashboard' : Dashboard,

    '/companies' : Companies,

    '/services' : Services,

    '/login' : Login,

    '/register' : Register,

    '/settings' : Settings,

    '/locations' : Locations,

    '/shipment/' : Shipment,

    '/shipment/:shipment_id' : Shipment,

    '/shipments/:shipments_ids' : Shipments,

    '/shipments/:shipments_ids/:likut' : Shipments,

    '/shipments/:shipments_ids/:likut/:tab' : Shipments,

    '/docs' : Docs,
    '/docs/rest' : Rest,
    '/docs/wordpress' : Wordress,
    '/docs/shopify' : Shopify,
    '/docs/wix' : Wix,
    '/docs/konimbo' : Konimbo,
    
    '*' : Dashboard,
}

export default mainRoutes;